import { render, staticRenderFns } from "./DeleteDevice.vue?vue&type=template&id=67b80696"
import script from "./DeleteDevice.vue?vue&type=script&lang=js"
export * from "./DeleteDevice.vue?vue&type=script&lang=js"
import style0 from "./DeleteDevice.vue?vue&type=style&index=0&id=67b80696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports